<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <div>
        <keep-alive>
          <!-- 需要缓存的组件name，对应页面组件的name: "productList" -->
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <!-- 不缓存的页面走普通router-view -->
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue